<template>
  <div v-for="(item, idx) in data" :key="idx" class="pt-8 lg:pt-12">
    <div class="h-[17px] w-full bg-[url(/assets/images/backgrounds/slashes-gray.png)] bg-repeat" />
    <div class="container pt-8 lg:pt-12">
      <div class="mb-10 text-3xl font-light text-blue-950 lg:text-6xl lg:font-normal">
        {{ item.title }}
      </div>
      <div v-for="(detail, index) in item.productDetails" :key="index" class="grid-default mb-10">
        <div
          class="col-span-6 flex gap-3 text-xl text-blue-800 lg:col-span-4 lg:flex-col lg:gap-8 lg:text-4xl lg:font-light"
        >
          <span
            class="inline-block h-[25px] min-h-[25px] w-[25px] min-w-[25px] rounded-full border-[5px] border-orange"
          />
          {{ detail.title }}
        </div>
        <div class="col-span-6 mt-4 lg:col-start-6 lg:col-end-13 lg:mt-12">
          <StructuredText class="text-blue-950" :data="detail.body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductDetailsListRecord } from '~/types/generated'

defineProps({
  data: {
    type: Array as PropType<ProductDetailsListRecord[]>,
    default: () => []
  }
})
</script>
